module.exports = __webpack_public_path__ + "workspace/static/img/cover-bg.c3b738e.png";